import api from "./api";

const NOTIFICATION_BASE_URL = "/shipping/notifications";
const SHIPPING_INQUIRY_BASE_URL = "/shipping/inquiry";

const ConversationNotificationService = {

    /**
     * Toutes les notifications destinées à l'utilisateur courant.
     *
     * GET /shipping/notifications
     */
    async getNotifications() {

        const response =
            await api.get(
                NOTIFICATION_BASE_URL
            );

        return response.data;
    },


    /**
     * Marquer une notification comme lue.
     *
     * PATCH /shipping/notifications/{notificationId}/read
     */
    async markNotificationAsRead(
        notificationId
    ) {

        await api.patch(
            `${NOTIFICATION_BASE_URL}/${notificationId}/read`
        );
    },


    /**
     * Récupérer la conversation liée à une inquiry.
     *
     * GET /shipping/inquiry/{inquiryId}/conversation
     */
    async getConversation(
        inquiryId
    ) {

        const response =
            await api.get(
                `${SHIPPING_INQUIRY_BASE_URL}/${inquiryId}/conversation`
            );

        console.log("The getConversation in ConversationNotificationService", response.data)

        return response.data;
    },


    /**
     * Récupérer les messages d'une conversation.
     *
     * GET /shipping/inquiry/{inquiryId}/conversation/messages
     */
    async getMessages(
        inquiryId
    ) {

        const response =
            await api.get(
                `${SHIPPING_INQUIRY_BASE_URL}/${inquiryId}/conversation/messages`
            );

        console.log("The getMessages in ConversationNotificationService", response.data)

        return response.data;
    },


    /**
     * Charger conversation + messages.
     *
     * Les deux appels sont exécutés en parallèle.
     */
    async getConversationDetails(
        inquiryId
    ) {

        const [
            conversation,
            messages
        ] = await Promise.all([

            this.getConversation(
                inquiryId
            ),

            this.getMessages(
                inquiryId
            )

        ]);

        return {
            conversation,
            messages
        };
    },


    /**
     * Envoyer un message.
     *
     * POST /shipping/inquiry/{inquiryId}/conversation/messages
     */
    async sendMessage(
        inquiryId,
        payload
    ) {

        const response =
            await api.post(
                `${SHIPPING_INQUIRY_BASE_URL}/${inquiryId}/conversation/messages`,
                payload
            );

        return response.data;
    }

};

export default ConversationNotificationService;